import React, { useState } from "react";
import { validateZipCodeRequest } from "../../../utils/validateZipCodeRequest";
import { useFormik } from "formik";
import { Box, Stack } from "@mui/material";
import BrentoTextField from "../../UI/BrentoTextField/BrentoTextField";
import BrentoLoadingButton from "../../UI/BrentoLoadingButton";
import BrentoButton from "../../UI/BrentoButton";
import Alert from "../../UI/Alert/Alert";
import { Link } from "react-router-dom";

const ZIPValidator = () => {
  const [validResponse, setValidResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleReset = () => {
    formik.setFieldValue("zipCode", "", false);
    setValidResponse(null);
  };

  const handleFullSubmit = async (formValues) => {
    setValidResponse(null);
    try {
      const zipCodeResponse = await validateZipCodeRequest(formValues.zipCode);
      console.log(zipCodeResponse);
      setValidResponse({
        isValid: zipCodeResponse.isValid,
        zipCode: formValues.zipCode,
      });
      setIsLoading(false);
    } catch (err) {}
  };

  const formik = useFormik({
    initialValues: {
      zipCode: "",
    },
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        handleFullSubmit(values);
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      }
    },
  });

  return (
    <Box component="form">
      <Stack direction="column" spacing={2}>
        <Stack direction="row" spacing={1}>
          <BrentoTextField
            label="Enter your ZIP Code"
            name="zipCode"
            value={formik.values.zipCode}
            type="number"
            onChange={formik.handleChange}
            fullWidth
            disabled={isLoading || validResponse}
          ></BrentoTextField>
          <BrentoLoadingButton
            pending={isLoading}
            onClick={formik.handleSubmit}
            disabled={!formik.values.zipCode || validResponse}
            type="submit"
          >
            Submit
          </BrentoLoadingButton>
        </Stack>
        {validResponse ? (
          validResponse.isValid ? (
            <Alert
              header="Great news!"
              type="success"
              content={
                <p>
                  <b>{validResponse.zipCode}</b> is within our delivery zone.
                  Check out our menu to get started on your online order.
                </p>
              }
              actions={
                <Stack direction="row" pt={2} spacing={1}>
                  <Link to="/menu">
                    <BrentoButton variant="contained" size="small">
                      View menu
                    </BrentoButton>
                  </Link>
                  <BrentoButton
                    onClick={() => handleReset()}
                    variant="outlined"
                    size="small"
                  >
                    Reset
                  </BrentoButton>
                </Stack>
              }
            />
          ) : (
            <Alert
              header="Oh bummer!"
              type="error"
              content={
                <p>
                  <b>{validResponse.zipCode}</b> is not currently within our
                  delivery zone. Check back soon to see if we have expanded to
                  your area, or look for a retail location near you.
                </p>
              }
              actions={
                <Stack direction="row" pt={2} spacing={1}>
                  <BrentoButton
                    onClick={() => handleReset()}
                    variant="outlined"
                    size="small"
                  >
                    Reset
                  </BrentoButton>
                </Stack>
              }
            />
          )
        ) : null}
      </Stack>
    </Box>
  );
};

export default ZIPValidator;
